module.exports = __webpack_public_path__ + "img/checkIcon.f4d154e7.svg";